const state = {
  fIndustry: null,
  fMarketArea: null,
  fFavoriteIndustries: [],
  fFavoriteMarketAreas: [],
  fSearchInputIndustry: null,
  fSearchInputMarketArea: null,
  fSearchIndustries: null,
  fSearchMarketAreas: null,
  fSearchLoadingIndustry: false,
  fSearchLoadingMarketArea: false,
  fProfileId: 0,
  salesRangeFrom: 0,
  salesRangeTo: 0,
  price: "",
  companiesCount: "",
  company: null,
  industryDialog: false,
  companyProfileId: 0,
  favoriteCompanies: [],
  searchInputCompany: null,
  searchCompanies: null,
  searchLoadingCompany: false,
  locnums: null,
  customizable: false,
};

const mutations = {
  F_SET_INDUSTRY: (state, fIndustry) => {
    state.fIndustry = fIndustry;
  },
  F_SET_MARKET_AREA: (state, fMarketArea) => {
    state.fMarketArea = fMarketArea;
  },
  F_SET_PROFILE_ID: (state, fProfileId) => {
    state.fProfileId = fProfileId;
  },
  F_SET_FAVORITE_INDUSTRIES: (state, fIndustry) => {
    state.fFavoriteIndustries = fIndustry;
  },
  F_SET_FAVORITE_MARKET_AREAS: (state, fMarketArea) => {
    state.fFavoriteMarketAreas = fMarketArea;
  },
  F_SET_SEARCH_INPUT_INDUSTRY: (state, fSearchInputIndustry) => {
    state.fSearchInputIndustry = fSearchInputIndustry;
  },
  F_SET_SEARCH_INPUT_MARKET_AREA: (state, fSearchInputMarketArea) => {
    state.fSearchInputMarketArea = fSearchInputMarketArea;
  },
  F_SET_SEARCH_INDUSTRIES: (state, fSearchIndustries) => {
    state.fSearchIndustries = fSearchIndustries;
  },
  F_SET_SEARCH_MARKET_AREAS: (state, fSearchMarketAreas) => {
    state.fSearchMarketAreas = fSearchMarketAreas;
  },
  F_SET_SEARCH_LOADING_INDUSTRY: (state, fSearchLoadingIndustry) => {
    state.fSearchLoadingIndustry = fSearchLoadingIndustry;
  },
  F_SET_SEARCH_LOADING_MARKET_AREA: (state, fSearchLoadingMarketArea) => {
    state.fSearchLoadingMarketArea = fSearchLoadingMarketArea;
  },
  F_PUSH_TO_FAVORITE_INDUSTRIES: (state, fIndustry) => {
    state.fFavoriteIndustries.push(fIndustry);
  },
  F_PUSH_TO_FAVORITE_MARKET_AREAS: (state, fMarketArea) => {
    state.fFavoriteMarketAreas.push(fMarketArea);
  },
  SET_SALES_RANGE_FROM: (state, salesRangeFrom) => {
    state.salesRangeFrom = salesRangeFrom;
  },
  SET_SALES_RANGE_TO: (state, salesRangeTo) => {
    state.salesRangeTo = salesRangeTo;
  },
  SET_PRICE: (state, price) => {
    state.price = price;
  },
  SET_COMPANY: (state, company) => {
    state.company = company;
  },
  SET_COMPANIES_COUNT: (state, companiesCount) => {
    state.companiesCount = companiesCount;
  },
  SET_INDUSTRY_DIALOG: (state, industryDialog) => {
    state.industryDialog = industryDialog;
  },
  SET_COMPANY_PROFILE_ID: (state, companyProfileId) => {
    state.companyProfileId = companyProfileId;
  },
  SET_FAVORITE_COMPANIES: (state, companies) => {
    state.favoriteCompanies = companies;
  },
  PUSH_TO_FAVORITE_COMPANIES: (state, company) => {
    state.favoriteCompanies.push(company);
  },
  SET_SEARCH_INPUT_COMPANY: (state, searchInputCompany) => {
    state.searchInputCompany = searchInputCompany;
  },
  SET_SEARCH_COMPANIES: (state, searchCompanies) => {
    state.searchCompanies = searchCompanies;
  },
  SET_SEARCH_LOADING_COMPANY: (state, searchLoadingCompany) => {
    state.searchLoadingCompany = searchLoadingCompany;
  },
  SET_LOCNUMS: (state, locnums) => {
    state.locnums = locnums;
  },
  PUSH_TO_LOCNUMS: (state, locnums) => {
    state.locnums.push(locnums);
  },
  REMOVE_FROM_LOCNUMS: (state, locnums) => {
    state.locnums = state.locnums.filter((item) => item !== locnums);
  },
  SET_CUSTOMIZABLE: (state, customizable) => {
    state.customizable = customizable;
  },
};

const getters = {
  fIndustry: (state) => state.fIndustry,
  fMarketArea: (state) => state.fMarketArea,
  fProfileId: (state) => state.fProfileId,
  fFavoriteIndustries: (state) => state.fFavoriteIndustries,
  fFavoriteMarketAreas: (state) => state.fFavoriteMarketAreas,
  fSearchInputIndustry: (state) => state.fSearchInputIndustry,
  fSearchInputMarketArea: (state) => state.fSearchInputMarketArea,
  fSearchIndustries: (state) => state.fSearchIndustries,
  fSearchMarketAreas: (state) => state.fSearchMarketAreas,
  fSearchLoadingIndustry: (state) => state.fSearchLoadingIndustry,
  fSearchLoadingMarketArea: (state) => state.fSearchLoadingMarketArea,
  salesRangeFrom: (state) => state.salesRangeFrom,
  salesRangeTo: (state) => state.salesRangeTo,
  price: (state) => state.price,
  company: (state) => state.company,
  companiesCount: (state) => state.companiesCount,
  industryDialog: (state) => state.industryDialog,
  companyProfileId: (state) => state.companyProfileId,
  favoriteCompanies: (state) => state.favoriteCompanies,
  searchInputCompany: (state) => state.searchInputCompany,
  searchCompanies: (state) => state.searchCompanies,
  searchLoadingCompany: (state) => state.searchLoadingCompany,
  locnums: (state) => state.locnums,
  customizable: (state) => state.customizable,
};

const findCompanies = {
  state,
  getters,
  mutations,
};

export default findCompanies;
